/* eslint-disable max-len */

import React from "react"
import styled from "styled-components"
import BaseSvgIcon from "./Base"

const Attachment = (props) => {
  return (
    <BaseSvgIcon viewBox="0 0 24 24" {...props}>
      <path
        className="st0"
        d="M8.8,17.1c-2.5,0-4.5-2-4.5-4.5v-8c0-1.9,1.6-3.5,3.5-3.5c1.9,0,3.5,1.6,3.5,3.5v8c0,1.4-1.1,2.5-2.5,2.5S6.3,14,6.3,12.6v-8c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v8c0,0.8,0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5v-8c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.5,1.1-2.5,2.5v8c0,1.9,1.6,3.5,3.5,3.5c1.9,0,3.5-1.6,3.5-3.5v-6c0-0.3,0.2-0.5,0.5-0.5s0.5,0.2,0.5,0.5v6C13.3,15.1,11.3,17.1,8.8,17.1z"
      />
    </BaseSvgIcon>
  )
}

export default styled(Attachment)``
